// Importing Foundation first
// ### Core
import 'what-input';

$(document).foundation();

// Import all your components here
// But don't code inside this file.
import './polyfill';
import './dropdownMenu';
import './accordion';
import './customRadios';
import './datepicker';
import './mobileMenu';
import './navigation';
import './load_events';
import './load_news';
import './load_associations';
import './load_commercants';
import './load_documents';
import './load_medias';
import './maps';
import './searchbar';
import './sliders';
import './tables';
import './textarea_autosize';
import './alert_modal';

// Enables HMR for JS files imported here
if (module.hot) {
  module.hot.accept();
}
// Signed by Choosit!
console.log(`%c Made with ❤️ by Choosit! `, `background-color: #009ee0; color: white;`);
